<form
  class="max-w-dialog"
  #dialogForm="ngForm"
  (ngSubmit)="onSubmit(dialogForm)"
  autocomplete="off"
>
  <app-ui-dialog-shell
    [title]="data.title"
    [ariaDescribedBy]="data.message && state() !== 'done' ? descriptionId : null"
  >
    @if (state() === 'done' && data.success; as success) {
      <div class="flex flex-col items-center py-2 text-center">
        <span
          class="mb-4 flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-status-success/10 text-status-success"
          aria-hidden="true"
        >
          <span class="block h-9 w-9">
            <app-ui-icon name="check-circle-outline" />
          </span>
        </span>
        @if (success.title) {
          <p class="text-body font-semibold">{{ success.title }}</p>
        }
        <p class="mt-1 block text-body-sm" role="status">{{ success.message }}</p>
      </div>
      <div class="dialog-actions mt-6 flex justify-end">
        <button appUiButton type="button" (click)="onDone()">
          {{ success.doneText || 'Done' }}
        </button>
      </div>
    } @else {
      @if (data.message) {
        <p class="message my-4 block text-body-sm" [id]="descriptionId" [innerHTML]="data.message"></p>
      }
      @if (data.form; as form) {
        <app-ui-field [label]="fieldLabel" [inputId]="'form-dialog-input'">
          @switch (data.formType) {
            @case ('textInput') {
              <input
                id="form-dialog-input"
                appUiInput
                name="inputValue"
                type="text"
                [placeholder]="form.placeholder ?? ''"
                [attr.aria-label]="fieldAriaLabel"
                [(ngModel)]="form.inputValue"
                [attr.maxlength]="form.maxlength"
                [disabled]="state() === 'sending'"
                required
              />
            }
            @case ('textArea') {
              <textarea
                class="min-h-36 resize-y"
                id="form-dialog-input"
                appUiInput
                name="inputValue"
                [placeholder]="form.placeholder ?? ''"
                [attr.aria-label]="fieldAriaLabel"
                [(ngModel)]="form.inputValue"
                [attr.maxlength]="form.maxlength"
                [disabled]="state() === 'sending'"
                required
                rows="5"
              ></textarea>
            }
          }
        </app-ui-field>
      }
      @if (submitError(); as error) {
        <p class="mt-2 text-body-sm text-status-danger" role="alert">{{ error }}</p>
      }
      <div class="dialog-actions mt-6 flex justify-end gap-2">
        <button
          appUiButton
          appearance="outline"
          tone="neutral"
          type="button"
          [disabled]="state() === 'sending'"
          (click)="onCancel()"
        >
          {{ data.cancelText || 'Cancel' }}
        </button>
        <button
          appUiButton
          type="submit"
          [disabled]="!dialogForm.form.dirty || !dialogForm.form.valid || state() === 'sending'"
        >
          @if (state() === 'sending') {
            {{ data.sendingText || 'Sending…' }}
          } @else {
            {{ data.submitText || 'Submit' }}
          }
        </button>
      </div>
    }
  </app-ui-dialog-shell>
</form>
